<template>
  <div>
    <table class="overall-stats-table">
      <thead>
        <tr>
          <th class="table-vtitle" v-for="(col, index) in keys" :key="'thead-' + col">{{$t(rowTitles[index])}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="(key, index) in keys" :key="'tkey-' + index">{{tableData.hasOwnProperty(key) && (tableData[key]).toFixed(2)}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: Array
  },
  data: () => ({
    tableData: {},
    keys: [
      'avg',
      'max',
      'min',
      'std'
    ],
    rowTitles: [
      'more.avg',
      'more.max',
      'more.min',
      'more.std'
    ]
  }),
  methods: {
    calculate: function () {
      this.tableData = {}
      this.keys.forEach(key => {
        if (this.data && this.data.length) {
          var d = this.data
          this.tableData.min = Math.min(...d)
          this.tableData.max = Math.max(...d)
          var avg = d.reduce((a, b) => (a + b)) / d.length
          this.tableData.avg = avg
          this.tableData.std = Math.sqrt(d.map(x => Math.pow(x - avg, 2)).reduce((a, b) => a + b) / d.length)
        }
      })
    }
  },
  watch: {
    data: {
      deep: true,
      handler () {
        this.calculate()
      }
    }
  },
  mounted () {
    this.calculate()
  }
}
</script>

<style>
table.overall-stats-table {
  width: 90%;
  font-size: small;
  margin: 0 20px 0;
}

table.overall-stats-table td, table.overall-stats-table th {
  text-align: center !important;
}
tr td:first-child {
  text-align: center !important;
}

table.overall-stats-table th {
  color: gray;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/StatisticsTable.vue